import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const links = [
  { to: '/', label: '首页' },
  { to: '/category/rexue', label: '分类' },
  { to: '/article/1', label: '资讯' },
  { to: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const solid = scrolled || open || location.pathname !== '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        solid ? 'bg-background-50/95 backdrop-blur border-b border-background-200' : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-open-fill text-lg" />
          </span>
          <span
            className={`font-heading text-xl ${solid ? 'text-foreground-950' : 'text-background-50'}`}
          >
            漫迹
          </span>
        </Link>

        <div className="hidden items-center gap-8 md:flex">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className={`whitespace-nowrap text-sm font-medium transition-colors ${
                location.pathname === l.to
                  ? 'text-primary-600'
                  : solid
                    ? 'text-foreground-700 hover:text-primary-600'
                    : 'text-background-100 hover:text-background-50'
              }`}
            >
              {l.label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <a
            href="#tracking"
            className="hidden whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            开启追更
          </a>
          <button
            type="button"
            aria-label="菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-lg text-xl md:hidden"
          >
            <i className={open ? 'ri-close-line' : 'ri-menu-line'} />
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <div className="mx-auto flex max-w-7xl flex-col gap-1 px-4 py-3">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="whitespace-nowrap rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-background-100 hover:text-primary-600"
              >
                {l.label}
              </Link>
            ))}
            <a
              href="#tracking"
              className="mt-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-center text-sm font-medium text-background-50 hover:bg-primary-600"
            >
              开启追更
            </a>
          </div>
        </div>
      )}
    </header>
  );
}